import { IIdName } from '@nimbus-library/features/shared/models/interfaces';
import { NimbusIcon } from '@nimbus-library/features/shared/directives/nimbus-icon.directive';
import { FilterBase } from '@nimbus-library/features/shared/components/nimbus-grid-filter/domain/filter-base.model';

export class FilterHierarchySelectOption implements IIdName {
  public id: string;
  public name: string;
  public icon?: NimbusIcon;

  public color?: string;
  public disabled?: boolean;

  // hierarchy
  public parentId?: string;
  public level?: number;
  public children?: FilterHierarchySelectOption[];

  public static findElementInHierarchy(id: string, options: FilterHierarchySelectOption[]): FilterHierarchySelectOption {
    const el = options.find((o) => o.id === id);

    if (el) {
      return el;
    }

    let index = 0;

    while (index < options.length) {
      const child = FilterHierarchySelectOption.findElementInHierarchy(id, options[index].children);

      if (child) {
        return child;
      }

      index++;
    }
  }

  public static getCount(options: FilterHierarchySelectOption[]): number {
    let count = 0;

    options.forEach((o) => {
      count++;

      if (o.children) {
        count += FilterHierarchySelectOption.getCount(o.children);
      }
    });

    return count;
  }

  public static getMaxDepth(options: FilterHierarchySelectOption[]): number {
    let maxDepth = 0;

    options.forEach((o) => {
      if (o.children) {
        maxDepth = Math.max(maxDepth, Math.max(o.level, FilterHierarchySelectOption.getMaxDepth(o.children)));
      } else {
        maxDepth = Math.max(o.level, maxDepth);
      }
    });

    return maxDepth;
  }

  public static getFirstSelected(selectedIds: Set<string>, options: FilterHierarchySelectOption[]): FilterHierarchySelectOption {
    let index = 0;

    while (index < options.length) {
      if (selectedIds.has(options[index].id)) {
        return options[index];
      }

      const child = FilterHierarchySelectOption.getFirstSelected(selectedIds, options[index].children);

      if (child) {
        return child;
      }

      index++;
    }
  }

  public static getSelection(selectedIds: Set<string>, options: FilterHierarchySelectOption[]): FilterHierarchySelectOption[] {
    let selection: FilterHierarchySelectOption[] = [];

    options.forEach((o) => {
      if (selectedIds.has(o.id)) {
        selection.push(o);
      }

      if (o.children) {
        selection = [...selection, ...FilterHierarchySelectOption.getSelection(selectedIds, o.children)];
      }
    });

    return selection;
  }
}

export interface FilterHierarchySelect extends FilterBase<string[]> {
  type: 'hierarchySelect';
  options: FilterHierarchySelectOption[];
  clearable?: boolean;
  searchable?: boolean;
}
